<template>
  <div class="row-bg">
    <div class="more" @click="toMore">查看更多...</div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="内部动态" name="inner">
        <el-row type="flex" :gutter="26">
          <el-col v-for="(item,index) of innerList" :key="'inner-'+index">
            <div class="images">
              <img :src="item.image" alt />
              <div class="bgbox"></div>
              <span @click="toDetail(item)">查看</span>
            </div>
            <div class="box-dynamic">
              <div class="text">
                <h3>{{item.title}}</h3>
                <p>{{item.subtitle}}</p>
              </div>
              <div class="detail" @click="toDetail(item)">
                查看详情
                <img src="../../assets/home/route2.png" alt />
              </div>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="外部动态" name="outer">
        <el-row type="flex" :gutter="26">
          <el-col v-for="(item,index) of outerList" :key="'outer-'+index">
            <div class="images">
              <img :src="item.image" alt />
              <div class="bgbox"></div>
              <span @click="toDetail(item)">查看</span>
            </div>
            <div class="box-dynamic">
              <div class="text">
                <h3>{{item.title}}</h3>
                <p>{{item.subtitle}}</p>
              </div>
              <div class="detail" @click="toDetail(item)">
                查看详情
                <img src="../../assets/home/route2.png" alt />
              </div>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
const dynamicListUri = "website/index/news/get/all";

export default {
  data() {
    return {
      activeName: "inner",
      innerList: [],
      outerList: []
    };
  },
  created() {
    this.getInnerList();
    this.getOuterList();
  },
  methods: {
    // 查看更多
    toMore() {
      if (this.activeName == "inner") {
        this.$router.push("/news/inner");
      } else {
        this.$router.push("/news/outer");
      }
    },
    // 详情
    toDetail(item) {
      this.$cache.set("showDynamic", item);
      this.$cache.set("rootin", 'home');
      this.$router.push("/new/detail");
    },
    // 获取内部动态
    getInnerList() {
      this.$api
        .get(dynamicListUri, {
          in_out: 1
        })
        .then(res => {
          this.innerList = res.list.slice(0, 3);
        });
    },
    // 获取外部动态
    getOuterList() {
      this.$api
        .get(dynamicListUri, {
          in_out: 2
        })
        .then(res => {
          this.outerList = res.list.slice(0, 3);
        });
    }
  }
};
</script>
<style lang="less" scoped>
.row-bg {
  width: 1200px;
  margin: 0 auto;
  margin-top: 36px;
  padding: 48px;
  position: relative;
  background: #fff;
  .more {
    position: absolute;
    top: 56px;
    right: 48px;
    width: 124px;
    height: 40px;
    background: #f2f2f2;
    text-align: center;
    line-height: 40px;
    font-size: 18px;
    color: #555555;
    z-index: 1;
    cursor: pointer;
  }
  /deep/ .el-tabs__header {
    .el-tabs__nav-wrap::after {
      height: 0;
    }
    .el-tabs__item {
      font-size: 30px;
      height: 60px;
      opacity: 0.2;
      font-weight: 500;
      color: #333;
    }
    .is-active {
      opacity: 1;
    }
  }
  .el-tabs__content {
    margin-top: 36px;
    .el-row {
      .el-col {
        width: 376px;
        font-size: 0;
        .images {
          overflow: hidden;
          position: relative;
          width: 100%;
          height: 196px;
          img {
            width: 100%;
            height: 100%;
            transform: scale(1, 1);
            transition: all 0.5s ease 0s;
          }
          span {
            display: none;
            color: #fff;
            position: absolute;
            width: 350px;
            height: 196px;
            top: 0;
            left: 0;
            font-size: 16px;
            text-align: center;
            line-height: 196px;
            z-index: 999;
            transition: all 0.5s ease 0s;
            cursor: pointer;
          }
        }
        .images:hover {
          img {
            transform: scale(1.1, 1.1);
            transition: all 0.5s ease 0s;
          }
          .bgbox {
            position: absolute;
            width: 350px;
            height: 196px;
            top: 0;
            left: 0;
            z-index: 99;
            background: #000;
            opacity: 0.4;
          }
          span {
            display: block;
            transition: all 0.5s ease 0s;
          }
        }
        .box-dynamic {
          border: 1px solid #eeeeee;
          border-radius: 0 0 2px 2px;
          padding-left: 16px;
          display: flex;
          align-items: center;

          .text {
            flex: 1;
            padding-right: 10px;

            h3 {
              font-size: 18px;
              font-weight: 500;
              color: #333;
              line-height: 27px;
              margin-top: 14px;
              overflow: hidden;
              display: -webkit-box; //将元素设为盒子伸缩模型显示
              -webkit-box-orient: vertical; //伸缩方向设为垂直方向
              -webkit-line-clamp: 1; //超出1行隐藏，并显示省略号
            }
            p {
              font-size: 15px;
              color: #999999;
              line-height: 15px;
              margin-top: 6px;
              margin-bottom: 14px;
              overflow: hidden;
              display: -webkit-box; //将元素设为盒子伸缩模型显示
              -webkit-box-orient: vertical; //伸缩方向设为垂直方向
              -webkit-line-clamp: 1; //超出1行隐藏，并显示省略号
            }
          }

          .detail {
            width: 95px;
            font-size: 16px;
            font-weight: 500;
            line-height: 24px;
            cursor: pointer;

            img {
              width: 17px;
              height: 3px;
              vertical-align: middle;
            }
          }
        }
      }
    }
  }
}
</style>
